import { createAsyncThunk } from '@reduxjs/toolkit';

import { APITenantUserMembershipGetSingle } from '../TenantUserMembership/TenantUserMembership.api';

import { APIUserGlobalRoleMembershipDelete } from './UserProfileGlobalRoles.api';

export const fetchUserProfileTenant = createAsyncThunk('userProfileGlobalRoles/fetchUserProfileTenant', async (item: { tenantId: string, userId: string }) => {
    const { userId, tenantId } = item;
    const response = await APITenantUserMembershipGetSingle({ userId, tenantId });
    return response.data;
});

export const deleteUserProfileGlobalRole = createAsyncThunk('userProfileGlobalRoles/deleteUserProfileGlobalRole', async (item: {
    tenantId: string,
    userId: string,
    globalRoleId?: string,
}) => {
    return APIUserGlobalRoleMembershipDelete(item);
});
